<div class="language-camps__description" *ngIf="withDescription" data-qa="languageCamps_description" i18n>
  Price includes tuition, accommodation, meals, excursions and activities
</div>

<div *ngIf="courseDetails$ | async as courseDetails" class="language-camps">
  <lx-single-selection-button-list-field
    (ngModelChange)="updateSelectedLanguage($event)"
    [ngModel]="courseDetails?.selectedLanguage"
    [options]="languages$ | async"
    bindValue="code"
    data-qa="languageCamps_languageField"
    i18n-title
    title="Language"
  ></lx-single-selection-button-list-field>
  <lx-location-selector-field
    data-qa="languageCamps_LocationField"
    [groupedSchoolLocations]="groupedSchoolLocations$ | async"
    (selectedValueChange)="updateSelectedSchoolLocation($event)"
    [selectedValue]="courseDetails?.selectedSchoolLocation"
  />
  <lx-juniors-course-selector-field
    [courses]="courses"
    (selectedCourseChanged)="updateSelectedCourse($event)"
    data-qa="languageCamps_CourseField"
  ></lx-juniors-course-selector-field>
  <div class="language-camps__date-fields">
    <lx-fixed-date-selector-field
      (selectedValueChange)="updateSelectedStartDate($event?.date)"
      [fixedDates]="startDates"
      [selectedValue]="{ date: courseDetails?.selectedStartDate }"
      [disabled]="!!!courseDetails?.selectedCourse"
      data-qa="languageCamps_StartDateField"
      i18n-label
      i18n-title
      label="Start date"
      title="Select a start date"
    >
      <ng-container *ngTemplateOutlet="formattedDate; context: { $implicit: courseDetails?.selectedStartDate }"></ng-container>
    </lx-fixed-date-selector-field>
    <lx-fixed-date-selector-field
      (selectedValueChange)="updateSelectedEndDate($event?.date)"
      [fixedDates]="endDates"
      [selectedValue]="{ date: courseDetails?.selectedEndDate }"
      [disabled]="!!!courseDetails?.selectedStartDate"
      data-qa="languageCamps_EndDateField"
      i18n-label
      i18n-title
      label="End date"
      title="Select an end date"
    >
      <ng-container *ngTemplateOutlet="formattedDate; context: { $implicit: courseDetails?.selectedEndDate }"></ng-container>
    </lx-fixed-date-selector-field>
  </div>
</div>
<ng-template #formattedDate let-date>
  {{ date ? (date | lxDate : DateFormat.SHORT_MONTH_NAME) : emptySelectionMsg }}
</ng-template>
